import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Flexed } from '../../../../../styles/GlobalComponents';
import {
  Position,
  StructureType
} from '../../../myTeamBackOffice.constants.js';
import {
  StructureGrayButton,
  StructureNavigation
} from '../../../MyTeamBackofficeStyled';
import AddNewMemberModal from '../../../common/AddNewMemberModal/AddNewMemberModal.js';
import {
  BackOnTopButton,
  DefaultPlacementButton,
  GoBottomButton
} from '../../common';
import { useAppSelector } from '../../../../../app/hooks';

const StructureNav = () => {
  const { t } = useTranslation('myTeam');
  const { isCanadaRestrictedUser, user } = useAppSelector(
    (state) => state.auth.userInfo
  );

  return (
    <StructureNavigation>
      <Flexed style={{ width: '100%' }}>
        <GoBottomButton
          position={Position.L}
          label={t('bottom_left')}
          isDisabled={false}
          structureType={StructureType.TEAM}
        />
        <BackOnTopButton />
        {!isCanadaRestrictedUser && (
          <StructureGrayButton
            style={{ width: 50, flex: 'none' }}
            orangeGradient
            onClick={() => window.open(`/connect-wallet/${user.id}`, '_blank')}>
            {t('add')}
          </StructureGrayButton>
        )}

        <GoBottomButton
          position={Position.R}
          label={t('bottom_right')}
          isDisabled={false}
          structureType={StructureType.TEAM}
        />
      </Flexed>
      {!isCanadaRestrictedUser && <DefaultPlacementButton />}
    </StructureNavigation>
  );
};

export default StructureNav;
